import * as angular from "angular";
import * as _ from "lodash";
import {IController, IWindowService} from "angular";
import {GlobalSearchEntity} from "../../models/global-search-entity.model";
import {GlobalSearchItemsType} from "../../types/global-search-items.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {FulfillmentStepService} from "../../../fulfillment/services/fulfillment-step-service.service";
import {FulfillmentSubTypeType} from "../../../fulfillment/types/fulfillment-sub-type.type";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {SuperSearchSortMethodType} from "../../types/super-search-sort-method.type";

export class globalSearchCtrl implements IController {

  orgId: any;
  siteId: any;
  onSelect: Function;

  public searchOptions = []

  public sortMethodOptions: SuperSearchSortMethodType[] = Object.values(SuperSearchSortMethodType);
  public selectedSortMethod: SuperSearchSortMethodType;

  public isOpened: boolean;
  public isExpanded: boolean = false;

  private loadLimit: number;
  private searchText: string;
  private readonly hasServicesListPermission: boolean;
  private readonly hasOrdersListPermission: boolean;
  private readonly hasStepsListPermission: boolean;
  private blockingSearchDatesRangeLimit: number;
  private siteDateFormat: string;
  public blockingSearchDate: string;
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;
  public generalSettings: ViewSettingsModel;
  public defaultGeneralSettings: ViewSettingsModel;
  public globalSearchTypes: typeof GlobalSearchItemsType = GlobalSearchItemsType;

  public noCache: boolean = true;

  /* @ngInject */
  constructor(private deliveriesService: DeliveriesService, private moment, private fulfillmentStepService: FulfillmentStepService,
              private omsService: OmsService, private IAMPermissions, private $window: IWindowService,
              private splitService: SplitService, private viewSettingsService: ViewSettingsService) {
    this.hasServicesListPermission = this.IAMPermissions.hasPermission('services.list');
    this.hasOrdersListPermission = this.IAMPermissions.hasPermission('oms.orders.list');
    this.hasStepsListPermission = this.IAMPermissions.hasPermission('fulfillment.step.list');

    this.blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();
    this.siteDateFormat = this.splitService.getDateAndTimeConfig().fullDate;
  }

  $onInit() {
    if (!!this.blockingSearchDatesRangeLimit) {
      this.blockingSearchDate = this.moment().subtract(this.blockingSearchDatesRangeLimit, 'day').startOf('day').format(this.siteDateFormat);
    }
    if (this.hasServicesListPermission) {
      this.searchOptions.push(GlobalSearchItemsType.Services);
    }
    if (this.hasOrdersListPermission) {
      this.searchOptions.push(GlobalSearchItemsType.Orders);
    }
    if (this.hasStepsListPermission) {
      this.searchOptions.push(GlobalSearchItemsType.Attempts);
    }

    this.loadLimit = 30;
    this.searchText = '';
    // Not persisted per user — the choice lives for the current page only and
    // resets to the site's configured method on every reload.
    this.selectedSortMethod = this.splitService.getSuperSearchSortMethod()
      || SuperSearchSortMethodType.SmartSearch;

    // this._getSiteDefaultSearch();
    // this._getUserDefaultSearch();

    this._getDefaultSearch();
  }

  focused() {
    this.isOpened = true;
    this.isExpanded = true;
  }

  blured() {
    this.isOpened = false;
    this.isExpanded = false;
  }

  onGlobalSearchTypeSelect(globalSearchType: GlobalSearchItemsType) {
    if (this.generalSettings?.id && this.generalSettings.holderType === ViewSettingsHolderType.User) {
      const generalSettingsCopy = {...this.generalSettings}

      if (!generalSettingsCopy.settings.globalSearch) {
        generalSettingsCopy.settings.globalSearch = {}
      }
      generalSettingsCopy.settings.globalSearch.value = globalSearchType;

      this.viewSettingsService.updateByUser(generalSettingsCopy.id, generalSettingsCopy)
        .then((generalSettings: ViewSettingsModel) => {
          this.generalSettings = generalSettings;
        })
    } else {
      const viewTableSettings = {
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.GeneralSettings,
        settings: {
          globalSearch: {
            value: globalSearchType
          }
        }
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((generalSettings: ViewSettingsModel) => {
          this.generalSettings = generalSettings
        })
    }
  }

  private _getDefaultSearch() {

    const siteDefaultHomePageSettings = this.viewSettingsService.getSiteGeneralSettings;
    const userDefaultHomePageSettings = this.viewSettingsService.getUserGeneralSettings;

    if (userDefaultHomePageSettings) {
      this.generalSettings = userDefaultHomePageSettings;
    } else if (siteDefaultHomePageSettings) {
      this.generalSettings = siteDefaultHomePageSettings;
    } else {
      this.generalSettings = this._getDefaultSearchSettings()
    }

  }

  private _getDefaultSearchSettings() {
    return this.defaultGeneralSettings ? angular.copy(this.defaultGeneralSettings) : {
      settings: {
        globalSearch: {
          value: GlobalSearchItemsType.Services
        }
      }
    }
  }


  // ******************************
  // Internal methods
  // ******************************

  querySearch(query): GlobalSearchEntity {
    let functionRef;

    // Pass autoComplete parameter based on partial search toggle
    // When partial search is enabled, autoComplete is true (default)
    // When partial search is disabled (exact search), autoComplete is false
    const partialSearchStorageValue = this.$window.localStorage.getItem('PARTIAL_SUPER_SEARCH');
    const autoComplete = _.isNull(partialSearchStorageValue) || (partialSearchStorageValue === 'true');

    // Read per query so a change to the dropdown takes effect on the next search.
    const sortMethod = this.selectedSortMethod;

    if (this.generalSettings?.settings?.globalSearch?.value === GlobalSearchItemsType.Services) {
      functionRef = this.deliveriesService.getGlobalSearch(query, this.orgId, this.siteId, undefined, undefined, this.loadLimit, autoComplete, sortMethod);
    } else if (this.generalSettings?.settings?.globalSearch?.value === GlobalSearchItemsType.Orders) {
      functionRef = this.omsService.getGlobalSearch(query, this.loadLimit, autoComplete, sortMethod);
    } else {
      functionRef = this.fulfillmentStepService.getGlobalSearch(query, this.loadLimit, autoComplete, sortMethod);
    }

    return functionRef
      .then((items) => {
        if (!!items?.length) {
          items[items.length - 1].isLast = true;
        }
        return items;
      })
  }

  selectedItemChange(item) {
    if (!!item) {
      this.searchText = '';
      this.blured();
      this.onSelect({result: item, type: this.generalSettings?.settings?.globalSearch?.value});
    }
  }

}

angular
  .module('bringoz.admin.search')
  .component('globalSearch', {
    bindings: {
      orgId: '<?',
      siteId: '<?',
      onSelect: '&'
    },
    template: require('./global-search.html').default,
    controller: globalSearchCtrl
  });
